import script from "./ServicesSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./ServicesSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./ServicesSkeleton.vue?vue&type=style&index=0&id=2757c730&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-rsmelinda2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2757c730"]])

export default __exports__